import QuestionHierarchy from './QuestionsHierarchy';

export default QuestionHierarchy;
